/**
 * Generated by orval v7.16.0 🍺
 * Do not edit manually.
 * 救急隊ポータルApp
 * OpenAPI spec version: 0.1.0
 */

/**
 * 事故種別
 */
export type IncidentTypeEnum =
  (typeof IncidentTypeEnum)[keyof typeof IncidentTypeEnum];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const IncidentTypeEnum = {
  FIRE: 'FIRE',
  NATURAL_DISASTER: 'NATURAL_DISASTER',
  DROWNING: 'DROWNING',
  TRAFFIC: 'TRAFFIC',
  WORK_ACCIDENT: 'WORK_ACCIDENT',
  SPORTS: 'SPORTS',
  GENERAL_INJURY: 'GENERAL_INJURY',
  ASSAULT: 'ASSAULT',
  SELF_INJURY: 'SELF_INJURY',
  SUDDEN_ILLNESS: 'SUDDEN_ILLNESS',
  HOSPITAL_TRANSFER: 'HOSPITAL_TRANSFER',
  HOSPITAL_TRANSFER_SUPPORT: 'HOSPITAL_TRANSFER_SUPPORT',
  DOCTOR_TRANSPORT: 'DOCTOR_TRANSPORT',
  EQUIPMENT_TRANSPORT: 'EQUIPMENT_TRANSPORT',
  OTHER: 'OTHER',
} as const;
